"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var table_1 = require("remota-client/component/table");
var button_1 = require("remota-client/component/button");
var icon_1 = require("remota-client/component/icon");
/**
 * 外部マスタマッピングのリスト
 */
var List = function () {
    return (react_1.default.createElement(structure_1.ListStructure, { selector: react_1.default.createElement("div", null), action: react_1.default.createElement(react_1.default.Fragment, null) },
        react_1.default.createElement(table_1.Table, null,
            react_1.default.createElement(table_1.Header, null,
                react_1.default.createElement(table_1.Row, null,
                    react_1.default.createElement(table_1.Cell, { col: 4 }, "\u7A2E\u5225"),
                    react_1.default.createElement(table_1.Cell, { col: 2 }))),
            react_1.default.createElement(table_1.Body, null,
                react_1.default.createElement(table_1.Row, null,
                    react_1.default.createElement(table_1.Cell, { col: 4 }, "Concur - \u53D6\u5F15\u5148\u30DE\u30B9\u30BF"),
                    react_1.default.createElement(table_1.ButtonCell, { col: 2 },
                        react_1.default.createElement(button_1.IconButton, { icon: icon_1.edit, to: "/external/concur-supplier" }, "\u7DE8\u96C6"))),
                react_1.default.createElement(table_1.Row, null,
                    react_1.default.createElement(table_1.Cell, { col: 4 }, "Concur - \u30AB\u30B9\u30BF\u30E0\u30EA\u30B9\u30C8"),
                    react_1.default.createElement(table_1.ButtonCell, { col: 2 },
                        react_1.default.createElement(button_1.IconButton, { icon: icon_1.edit, to: "/external/concur-custom-list" }, "\u7DE8\u96C6"))),
                react_1.default.createElement(table_1.Row, null,
                    react_1.default.createElement(table_1.Cell, { col: 4 }, "Concur - \u30CF\u30A4\u30D1\u30FC\u30DA\u30FC\u30B9\u30C8\u66F4\u65B0"),
                    react_1.default.createElement(table_1.ButtonCell, { col: 2 },
                        react_1.default.createElement(button_1.IconButton, { icon: icon_1.edit, to: "/external/concur-hyper-paste" }, "\u7DE8\u96C6"))),
                react_1.default.createElement(table_1.Row, null,
                    react_1.default.createElement(table_1.Cell, { col: 4 }, "CSV - \u30CF\u30A4\u30D1\u30FC\u30DA\u30FC\u30B9\u30C8\u66F4\u65B0"),
                    react_1.default.createElement(table_1.ButtonCell, { col: 2 },
                        react_1.default.createElement(button_1.IconButton, { icon: icon_1.edit, to: "/external/csv-hyper-paste" }, "\u7DE8\u96C6")))))));
};
exports.List = List;
